import React from "react";
import Responsive from "react-responsive";

const MobileView = ({ ...rest }) => <Responsive {...rest} maxWidth={767} />;

export default MobileView;
